import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromFilter from '../reducers/filter.reducer';

export const getFilterData = createFeatureSelector<fromFilter.Filter>('filter');

export const getFilterDisplayView = createSelector(
  getFilterData,
  (state: fromFilter.Filter) => state.displayView,
);
